export const GPS_DEVICES_BUSY = "GPS_DEVICES_BUSY";
export const GPS_DEVICES_COUNT = "GPS_DEVICES_COUNT";
export const GPS_DEVICES = "GPS_DEVICES";
export const GPS_DEVICE_POSITIONS = "GPS_DEVICE_POSITIONS";
export const GPS_DEVICE_EVENTS = "GPS_DEVICE_EVENTS";
export const GPS_GEOFENCES = "GPS_GEOFENCES";
export const GPS_NOTIFICATIONS = "GPS_NOTIFICATIONS";
